import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Layout from "../layouts/Layout";
import ActiveDeals from "../components/ActiveDeals";
import ClosedDeals from "../components/ClosedDeals";
import { primaryShade1, primaryShade4, white } from "../styles/color";

class Deals extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0
    };
  }
  handleChange = (event, value) => {
    this.setState({ value });
  };
  componentWillMount() {
    document.addEventListener(
      "deviceready",
      function() {
        var exitApp = false,
          intval = setInterval(function() {
            exitApp = false;
          }, 1000);
        document.addEventListener(
          "backbutton",
          function(e) {
            e.preventDefault();
            if (exitApp) {
              clearInterval(intval)(
                window.navigator.app && window.navigator.app.exitApp()
              );
            } else {
              exitApp = true;
              this.props.history.goBack();
            }
          },
          false
        );
      },
      false
    );
  }
  render() {
    const { value } = this.state;
    const {
      user,
      allDeals,
      activeDeals,
      closedDeals,
      fetchDealDetails,
      transactions,
      organisations,
      invoicePrintData
    } = this.props;
    return (
      <Layout
        position="fixed"
        bottomNavigation={true}
        appBar
        appBarTitle={"TRANSACTIONS"}
        appBarRightIcon={true}
        selectedValue={0}
      >
        <div
          style={{
            marginTop: "56px"
          }}
        >
          <Tabs
            TabIndicatorProps={{
              style: { backgroundColor: primaryShade4 }
            }}
            value={value}
            onChange={this.handleChange}
            fullWidth
            style={{ backgroundColor: primaryShade1, color: white }}
          >
            <Tab
              label="ACTIVE"
              style={{
                backgroundColor: value === 0 ? primaryShade4 : primaryShade1
              }}
            />
            <hr />
            <Tab
              label="CLOSED"
              style={{
                backgroundColor: value === 2 ? primaryShade4 : primaryShade1
              }}
            />
          </Tabs>

          {value === 0 && (
            <ActiveDeals
              user={user}
              activeDeals={activeDeals}
              invoicePrintData={invoicePrintData}
              fetchDealDetails={fetchDealDetails}
              transactions={transactions}
              organisations={organisations}
            />
          )}
          {value === 2 && (
            <ClosedDeals
              allDeals={allDeals}
              transactions={transactions}
              closedDeals={closedDeals}
            />
          )}
        </div>
      </Layout>
    );
  }
}
Deals.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withRouter(Deals);
